import React, {Component} from "react";
import {ScreensRoot} from "../../screens/Root";
import "./App.scss";
import SessionTimer from "../UI/SessionTimer/SessionTimer";
import Breadcrumb from "../UI/Breadcrumb/Breadcrumb";
import $ from "jquery";
import TagManager from "react-gtm-module";
import { consultarCodigoGTM } from "../../redux/modules/consultarCodigoGTM/actions";
import { connect } from "react-redux";
import * as R from "ramda";
import { REQUEST } from "../../util/Request";
export class AppSinConectar extends Component<any, any> {
  
  componentWillMount() {
    this.props.dispatch(consultarCodigoGTM());
  }

  componentWillReceiveProps(nextProps: any) {
    if (nextProps.estadoConsultarCodigoGTM === REQUEST.SUCCESS) {
      // Load Google Tag Manager
      //console.log(nextProps);
      //console.log("ACA:");
      //console.log(window);
      window.__jquery = $;
      //(window as any).__jquery = $;
      

      TagManager.initialize({
        gtmId: nextProps.codigoGTM
      });
    }
  }

  render() {
    return (
      <div className="app">
        <Breadcrumb/>
        <ScreensRoot/>
        <SessionTimer/>
      </div>
    );
  }
}

const App: any = connect(
  (store: any) => {
    return {
      codigoGTM: R.pathOr(undefined, ["recDocInternet", "GTM", "codigoGTM"])(store),
      estadoConsultarCodigoGTM: R.pathOr(undefined, ["recDocInternet", "GTM", "estadoConsultarCodigoGTM"])(store),
    };
  }
)(AppSinConectar);

export default App;
